import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import { useLocation } from "react-router-dom"
import { useMemo } from "react"
import { ProfileSliceState } from "slices/auth/profile/reducer"
import EmployeeUtility from "utils/models/employee-utility"

const selectProfile = createSelector(
    (state: any) => state.Profile,
    ({ employee }: ProfileSliceState) => ({
        employee
    })
)

interface SupportEmailReturnResults {
    mailtoHref: string | null
}

const SUBJECT = "IbexIQ Support Request"

const useSupportEmail = (): SupportEmailReturnResults => {
    const { employee } = useSelector(selectProfile)
    const { pathname } = useLocation()

    const mailtoHref = useMemo(() => {
        const to = process.env.REACT_APP_IT_SUPPORT_EMAIL
        if (!to) return null

        const body = [
            "What happened:",
            "",
            "",
            "What you expected:",
            "",
            "",
            "Steps to reproduce:",
            "",
            "(Please attach a full page screenshot, including the URL in the address bar)",
            "",
            "-- Please leave the details below, they help IT investigate --",
            `User: ${EmployeeUtility.fullName(employee, "Unknown")}`,
            `Email: ${employee?.companyEmail ?? "Unknown"}`,
            `Page: ${window.location.origin}${pathname}`,
            `Browser: ${navigator.userAgent}`,
        ].join("\n")

        return `mailto:${to}?subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(body)}`
    }, [employee, pathname])

    return { mailtoHref }
}

export default useSupportEmail
